import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import {
  Row, Col, Spin,
} from 'antd';
import Apps from './Apps';
import Navigation from '../public/navigation';
const store = ['modeListStore', 'homeStore', 'listStore']

@inject(...store)
@observer
class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      width: 1340,
      col: 6,
    }
  }
  componentDidMount() {
    const {
      homeStore: { type },
      listStore: { params: { searchValue } },
      modeListStore: { getMould, init, getCollectList, setMobxState },
    } = this.props;
    init();
    this.handlerResize();
    const modeType = getMould(toJS(type).id);
    setMobxState({ modeType });
    getCollectList({ searchValue, module: modeType });
    window.addEventListener('scroll', this.scrollHandler);
    window.addEventListener('resize', this.handlerResize);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollHandler);
    window.removeEventListener('resize', this.handlerResize);
  }

  handlerResize = () => {
    const { col } = this.state;
    const { modeListStore: { setMobxState, pageSize } } = this.props;
    const cWidth = document.clientWidth || document.documentElement.clientWidth;
    const sWidth = document.scrollWidth || document.documentElement.scrollWidth;
    const docWidth = Math.max(cWidth, sWidth) - 190;
    
    const cHeight = document.clientHeight || document.documentElement.clientHeight;
    const sHeight = document.scrollHeight || document.documentElement.scrollHeight;
    const docHeight= Math.max(cHeight, sHeight) - 430;
    const row = Math.ceil(docHeight / 150);
    let span = Math.ceil(275 / docWidth * 24);
    if (span === 5 || span === 7) span += 1;
    if (span > 8 && span < 12) span = 12;
    if (span > 12) span = 24;
    if (col !== span) this.setState({ width: docWidth, col: span });
    if (col * row !== pageSize) setMobxState({ pageSize: col * row});
  }

  scrollHandler = () => {
    if (this.modeList) {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > this.scrollTop) {
        const { listStore: { params: { searchValue } }, homeStore: { type }, modeListStore: { getMould, getCollectList, current, modeCount, pageSize, loading, setMobxState } } = this.props;
        if (current * pageSize < modeCount && !loading) {
          const modeType = getMould(toJS(type).id);
          getCollectList({ searchValue, current: current + 1, pageSize, module: modeType });
          setMobxState({ current: current + 1, modeType });
        }
      }
      this.scrollTop = scrollTop;
    }
  }
  getNavs = () => {
    const { location: { query: { id } } } = this.props;
    const navs = [
      { key: '1', breadcrumbName: '云商店', path: '/' },
      { key: '2', breadcrumbName: id === 'mode' ? '建模应用' : id === 'dev' ? '定制开发' : '非标应用', path: '/' },
      { key: '3', breadcrumbName: '我的收藏', },
    ];
    return navs;
  }
  render() {
    const { col } = this.state;
    let { location: { query }, homeStore: { setType }, modeListStore: { routing, loading, collectList, setMobxState } } = this.props;
    collectList = toJS(collectList);
    const isSearch = window.location.hash.indexOf('app/search') >= 0;
    return (
      <div ref={c => this.modeList = c} className='home-page-theme-list home-page-mode-list' style={isSearch ? { paddingTop: 0 } : {}}>
        <Navigation datas={this.getNavs()} onClick={(obj) => {
         if (obj.key === '1') {
          setType('all', '全部应用');
          routing.push('/');
         }
          else routing.push({
            pathname: obj.path,
            query,
          })
        }}/>
        <Spin spinning={loading}>
          <Row className="mode-content">
            {
              collectList && collectList.length > 0 ? collectList.map(t => (
                <Col
                  key={t.s_id}
                  span={col}
                  onMouseOver={(e) => {
                    setMobxState({ appHotSelected: t.s_id });
                    e.stopPropagation && e.stopPropagation();
                    e.preventDefault && e.preventDefault();
                    e.nativeEvent && e.nativeEvent.preventDefault();
                  }}
                  onMouseOut={(e) => {
                    setMobxState({ appHotSelected: '' });
                    e.stopPropagation && e.stopPropagation();
                    e.preventDefault && e.preventDefault();
                    e.nativeEvent && e.nativeEvent.preventDefault();
                  }}
                >
                  <Apps data={t} />
                </Col>
              )) : !loading ? (
                  <div style={{ paddingTop: 120 }}>
                    <div className="icon-Cloud-No-data" />
                    <p style={{ textAlign: 'center' }}>暂无数据</p>
                  </div>
                ) : null
            }
          </Row>
        </Spin>
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/mode/CollectList.js